<template>
    <div class="audio_wrap">
        <audio :src="url" controls style="display:none" ref="fileList_audio" @timeupdate="timeupdate($event)" @ended="ended"></audio>
        <p @click.stop="play(item,'fileList_audio'+ index)">
            <i class="iconfont" v-if="paused" style="font-size: 16px">&#xe65a;</i>
            <i class="iconfont" v-else>&#xe653;</i>
            
        </p>
        <div class="play_process">
            <div @mousedown="isDraging = true" @mouseup="isDraging = false">
                <el-slider v-model="audioValue" class="audio_process_pre" :min="0" :max="duration" height="3px" @change="changeAudio" :format-tooltip="formatTooltip"></el-slider>
            </div>
            <div class="playTime">
                <span>{{audioValue| handleDuration}}</span>
                <span>{{duration | handleDuration}}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AudioEle',
    props: {
        duration: {
            type: Number,
            default: 0,
        },
        url: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            paused: false,
            isDraging: false,
            audioValue: 0
        }
    },
    methods: {
        timeupdate(e) {
            if(!this.isDraging) {
                this.audioValue =  Math.floor(e.target.currentTime)
            }
        },
        play() {
            let audioDom = this.$refs.fileList_audio
            if(audioDom.paused) {
                this.audioValue &&  this.audioValue>0 ? audioDom.currentTime = this.audioValue: ''
                this.paused = true
                audioDom.play()
            } else {
                audioDom.pause()
                this.paused = false
            }
        },
        changeAudio(value) {
            let audioDom = this.$refs.fileList_audio
            audioDom.currentTime = value
        },
        formatTooltip(value) {
           return this.$options.filters['handleDuration'](value)
        },
        ended() {
            this.paused = false
            this.audioValue = 0
        }
    },
    filters: {
        handleDuration(value) {
            if(Number(value).toString() !== 'NaN') {
                let h = Math.floor(value / 3600 % 24).toString().padStart(2, 0)
                let m = Math.floor(value / 60 % 60).toString().padStart(2, 0)
                let s = (value% 60).toString().padStart(2, 0)
                return  h+ ':' + m+ ':' +s
            } else {
                return '00:00:00'
            }
        }
    },
}
</script>
<style lang="less">
    .audio_process_pre {
        .el-slider__runway {
            margin: 5px 0;
            background-color: #2d2366;
            height: 3px;
        }
        .el-slider__bar {
            height: 3px;
            background-color: #8a5cfe;
        }
        .el-tooltip.el-slider__button {
            width: 10px;
            height: 10px;
        }
    }
</style>
<style lang="less" scoped>
    .audio_wrap {
        display: flex;
        align-items: center;
        padding:0 8px;
        box-sizing: border-box;
        .play_process {
            flex: 1;
            width: 0;
            padding-left: 10px;
            display: flex;
            flex-direction: column;
            .playTime {
                display: flex;
                justify-content: space-between;
                color: #999;
                font-size: 12px;
                line-height: 12px;
                margin-top: 4px;
                span {
                    display: inline-block;
                }
            }
        }
        p {
            width: 32px;
            height: 32px;
            background-color: #8a5cfe;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .iconfont {
                font-size: 12px;
                color: #fff;
            }
        }
}
</style>